export default __webpack_public_path__ + "static/media/resume1.1b68c762.png";